import React from 'react';
import * as styledComponents from 'styled-components';
import { ThemeProvider as StyledProvider } from 'styled-components';
var _a = styledComponents, styled = _a.default, css = _a.css, keyframes = _a.keyframes, ThemeContext = _a.ThemeContext, createGlobalStyle = _a.createGlobalStyle;
var useTheme = function () {
    return React.useContext(ThemeContext);
};
var ThemeProvider = function (_a) {
    var value = _a.value, children = _a.children;
    return (React.createElement(StyledProvider, { theme: value.theme }, children));
};
export { css, keyframes, styled, useTheme, ThemeProvider, createGlobalStyle };
